import React, { useState } from "react";
import "./AccountSupport.scss";
import Dialog from "@mui/material/Dialog";
import {
  Box,
  Button,
  ListItem,
  List,
  ListItemText,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBefore from "@mui/icons-material/NavigateBefore";
import ListItemIcon from "@mui/material/ListItemIcon";
import ForgotPassword from "../../components/ForgotPassword";
import ForgotUserName from "../../components/ForgotUserName";
import CreateAccount from "../../components/CreateAccount";
import TechSupportLine from "../../components/TechSupportLine";

const AccountSupportOption = ({
  setForgotPassword,
  setForgotUserName,
  setCreateAccount,
  setTechnicalSupport,
  toggleButton,
}) => {
  const handleClick = (input) => {
    if (input === "password") setForgotPassword(true);
    else if (input === "username") setForgotUserName(true);
    else if (input === "account") setCreateAccount(true);
    else if (input === "techsupport") setTechnicalSupport(true);

    toggleButton(true);
  };
  return (
    <Box m={1} align="center">
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid item xs={12} style={{ backgroundColor: "#DBDDDC" }}>
          Select Support Option
        </Grid>
        <Grid item xs={12} md={5}>
          <List component="nav">
            <ListItem
              button
              onClick={() => handleClick("password")}
              style={{ paddingLeft: "7px" }}
            >
              <ListItemText primary="Forgot Password" />
              <ListItemIcon style={{ minWidth: "0px" }}>
                <NavigateNextIcon />
              </ListItemIcon>
            </ListItem>
            <Divider />
            <ListItem
              button
              onClick={() => handleClick("username")}
              style={{ paddingLeft: "7px" }}
            >
              <ListItemText primary="Forgot Username" />
              <ListItemIcon style={{ minWidth: "0px" }}>
                <NavigateNextIcon />
              </ListItemIcon>
            </ListItem>
            <Divider />
            <ListItem
              button
              onClick={() => handleClick("account")}
              style={{ paddingLeft: "7px" }}
            >
              <ListItemText primary="Create an Account" />
              <ListItemIcon style={{ minWidth: "0px" }}>
                <NavigateNextIcon />
              </ListItemIcon>
            </ListItem>
            <Divider />
            <ListItem
              button
              onClick={() => handleClick("techsupport")}
              style={{ paddingLeft: "7px" }}
            >
              <ListItemText primary="Tech Support Line" />
              <ListItemIcon style={{ minWidth: "0px" }}>
                <NavigateNextIcon />
              </ListItemIcon>
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Box>
  );
};

const AccountSupport = ({ close }) => {
  const [forgotPassword, setForgotPassword] = useState(false);
  const [forgotUserName, setForgotUserName] = useState(false);
  const [createAccount, setCreateAccount] = useState(false);
  const [technicalSupport, setTechnicalSupport] = useState(false);
  const [hideShow, setHideShow] = useState(false);

  const handleBack = () => {
    if (forgotPassword) setForgotPassword(false);
    else if (forgotUserName) setForgotUserName(false);
    else if (createAccount) setCreateAccount(false);
    else setTechnicalSupport(false);

    setHideShow(false);
  };

  return (
    <Dialog fullScreen open={true}>
      <Box m={2} align="center">
        <h2 className="sectionTitle center">
          {hideShow && (
            <Button
              style={{ color: "#ffffff", minWidth: "0px" }}
              component="span"
              onClick={() => handleBack()}
            >
              <NavigateBefore />
            </Button>
          )}
          Account Support & Help
          <Button
            onClick={close}
            style={{
              backgroundColor: "#6b84b4",
              color: "#ffffff",
              fontFamily: "Arial Narrow",
            }}
          >
            Done
          </Button>
        </h2>
        {!forgotPassword &&
          !forgotUserName &&
          !createAccount &&
          !technicalSupport && (
            <AccountSupportOption
              setForgotPassword={setForgotPassword}
              setForgotUserName={setForgotUserName}
              setCreateAccount={setCreateAccount}
              setTechnicalSupport={setTechnicalSupport}
              toggleButton={setHideShow}
            />
          )}
        {forgotPassword && <ForgotPassword />}
        {forgotUserName && <ForgotUserName />}
        {createAccount && <CreateAccount />}
        {technicalSupport && <TechSupportLine />}
      </Box>
    </Dialog>
  );
};

export default AccountSupport;
